import { regexConstants, errorMsg1 } from '../../constants/regEx';
export const robberyObj = {
    part_number:'',
    removal_date:null,
    part_description:'',
    part_location:'',
    reason_for_removal:'',
    date_verified_removed_from_aircraft:null,
    date_verified_installed_on_aircraft:null,
    date_verified_in_store_house:null,
    price:'',
    work_card_no:'',
    comments:''
  };
export const robberyHd = [
  { label: 'Action(s)', sortOption: false, sticky: true},
  { id: 'part_number', label: 'Part Number', sortOption: true, width: '80px' },
  { label: 'Part Description', sortOption: false, width: '150px' },
  { id:'part_location', label: 'Location', sortOption: true, width: '50px' },
  { label: 'Removal Date', sortOption: false, width: '90px' },
  { label: 'Reason For Removal', sortOption: false, width: '140px' },
  { label: 'Date Verified Removed from A/C', sortOption: false, width: '220px' },
  { label: 'Date Verified in Storehouse', sortOption: false, width: '220px' },
  { label: 'Date Verified installed on A/C', sortOption: false, width: '200px' },
  { label: 'Price', sortOption: false, width: '100px' },
  { label: 'Work Card No.', sortOption: false, width: '120px' },
  { label: 'Remarks', sortOption: false, width: '150px' },
];
  export const robberyFilterOps = {
    part_number: {
      inputType: 'text',
      placeholder: 'Search by Part Number',
      title:'Part Number'
    },
    part_description: {
      inputType: 'text',
      placeholder: 'Search by Part Description',
      title:'Part Description'
    },
    part_location: {
      inputType: 'text',
      placeholder: 'Search by Part Location',
      title:'Part Location'
    }
  }
export const errorCode = {
  part_number:{
    0:'',
    1: 'Please enter part number',
  },
  part_numberObj:{
    required: true,
  }
}
